import { forwardRef, HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

export interface PageSectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export const PageSection = forwardRef<HTMLElement, PageSectionProps>(function PageSection(
  { title, description, actions, className, children, ...rest },
  ref
) {
  return (
    <section ref={ref} data-tss-ui="" className={cn('tss-section', className)} {...rest}>
      {(title || description || actions) && (
        <header className="tss-section__header">
          <div className="tss-section__heading">
            {title && <h2 className="tss-section__title">{title}</h2>}
            {description && <p className="tss-section__description">{description}</p>}
          </div>
          {actions && <div className="tss-section__actions">{actions}</div>}
        </header>
      )}
      <div className="tss-section__body">{children}</div>
    </section>
  );
});
